import React, { Component } from 'react'
import HomeAbout from './HomeAbout'
import BannerImg from './mainbanner.jpg'


export default class HomeFull extends Component {

    state = {
        isAbout : false
    }

    componentDidMount() {
        this.fontSizeFx()
        window.addEventListener('resize', this.fontSizeFx)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.fontSizeFx)
    }

    fontSizeFx = () => {

        const boxWidth = document.getElementById('HomeRight').offsetWidth;
        const txtWidth = document.getElementsByClassName('HomeBigTxt')

        txtWidth[0].style.fontSize = boxWidth / 4 + 'px'
        txtWidth[1].style.fontSize = boxWidth / 4 + 'px'
        txtWidth[0].style.lineHeight = boxWidth / 4 + 'px'
        txtWidth[1].style.lineHeight = boxWidth / 4 + 'px'
    }

    aboutFx = () => {
    	
        if(this.state.isAbout) {
            this.setState(
                { isAbout : false }
            )
        } else {
            this.setState(
                { isAbout : true }
            )
        }
        
    }

    render() {

        const Banner = {
            backgroundImage: 'url(' + BannerImg + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '100vh',
            zIndex: 2
        }


        return (

            <div className='WideBanner' style={Banner}>

                <div id='HomeRight'>

                    <div id='HomeAboutIcon' onClick={this.aboutFx}>
                        <i className='material-icons'>live_help</i>
                        <span>About</span>   
                    </div>
                  
                    <div id='HomeTxt'>

                        <div>
                            <h1 className='HomeBigTxt'>FLY</h1>
                            <h1 className='HomeBigTxt'>AWAY</h1>
                        </div>

                        <div id='HomeSmallTxt'>
                            <p>"WHETHER YOU THINK YOU CAN OR THINK YOU CAN'T, YOU'RE RIGHT."</p>
                        </div>

                    </div>

                </div>

                {this.state.isAbout ? <HomeAbout closeMe = {this.aboutFx}/> : null }

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/home/HomeFull.js